import { useCallback, useMemo } from 'react';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import Button from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import { ReceiptRequireAttachment } from 'src/constants/permissionsList';
import useConfirm from 'src/hooks/useConfirm';
import usePermission from 'src/hooks/usePermissions';
import useReceiptDetails from 'src/hooks/useReceiptDetails';

const CompleteReceipt = () => {
  const { receiptData, saveReceiptDetails, getMessages, isReceiptActionButtonsDisabled, isSaving } =
    useReceiptDetails();
  const { confirm } = useConfirm();

  const handleComplete = useCallback(async () => {
    await confirm({
      title: 'Complete',
      content: (
        <p>
          This Receipt will be Completed. Use of Re-open to edit is allowed until the Receipt is
          linked to an Invoice record. Do you wish to continue?
        </p>
      ),
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
      cancelColor: 'info',
      width: '500px',
    }).then(async (isCompleteClicked) => {
      if (isCompleteClicked) {
        saveReceiptDetails(false);
      }
    });
  }, [confirm, saveReceiptDetails]);

  const doesReceiptRequireAttachment = usePermission({
    permissions: ReceiptRequireAttachment,
  });

  const messages = useMemo(
    () =>
      doesReceiptRequireAttachment && !receiptData.attachments.length
        ? ['Receipt Requires an attachment']
        : [],
    [doesReceiptRequireAttachment, receiptData.attachments.length]
  );

  const isDisabled = isReceiptActionButtonsDisabled(!!messages.length);

  return (
    <PopUp
      content={<PopUpContentWrapper type="Error" contents={getMessages(messages)} />}
      show={isDisabled}
    >
      <Button
        onClick={handleComplete}
        buttonState={receiptData.completeReceipt}
        disabled={isDisabled}
        loading={isSaving}
      >
        Complete
      </Button>
    </PopUp>
  );
};

export default CompleteReceipt;
